import React from 'react';
import { Segment } from 'semantic-ui-react';

import { connect } from 'react-redux';
import { updateUser } from '../actions/users';

import UserForm from '../components/UserForm';

class UserEdit extends React.Component {
  render() {
    return (
      <Segment basic className="UserEdit">
        <UserForm
          user={this.props.currentUser}
          onSubmit={this.props.handleSubmit}
        />
      </Segment>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  handleSubmit: attributes => {
    dispatch(updateUser(attributes));
  }
});

export default connect(
  null,
  mapDispatchToProps
)(UserEdit);



// WEBPACK FOOTER //
// ./src/containers/UserEdit.js